<template>
    <label class="app-switch" :class="[`app-switch--${size}`, { 'app-switch--disabled': disabled }]"
           :title="title">
        <input type="checkbox" class="app-switch__input"
               :checked="modelValue" :disabled="disabled"
               @change="$emit('update:modelValue', $event.target.checked)" />
        <span class="app-switch__track">
            <span class="app-switch__thumb"></span>
        </span>
        <span v-if="textoLabel" class="app-switch__label">{{ textoLabel }}</span>
    </label>
</template>

<script>
export default {
    name: 'AppSwitch',
    props: {
        // v-model
        modelValue: { type: Boolean, default: false },
        // Texto fixo ao lado do switch (independente do estado)
        label:      { type: String,  default: '' },
        // Textos que variam conforme ligado/desligado (têm prioridade sobre "label")
        onLabel:    { type: String,  default: '' },
        offLabel:   { type: String,  default: '' },
        size:       { type: String,  default: 'md' }, // sm | md
        disabled:   { type: Boolean, default: false },
        title:      { type: String,  default: '' },
    },
    emits: ['update:modelValue'],
    computed: {
        textoLabel() {
            if (this.onLabel || this.offLabel) {
                return this.modelValue ? this.onLabel : this.offLabel;
            }
            return this.label;
        },
    },
};
</script>

<style scoped>
.app-switch {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    cursor: pointer;
    user-select: none;
    line-height: 1;
}
.app-switch--disabled {
    cursor: not-allowed;
    opacity: 0.55;
}

/* esconde o checkbox nativo, mas mantém acessível */
.app-switch__input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;
}

/* trilho */
.app-switch__track {
    position: relative;
    flex: 0 0 auto;
    display: inline-block;
    background: #cbd3e1;
    border-radius: 999px;
    transition: background-color 0.2s ease;
}
.dark .app-switch__track { background: #3b4863; }

/* botão deslizante */
.app-switch__thumb {
    position: absolute;
    top: 50%;
    left: 2px;
    transform: translateY(-50%);
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    transition: left 0.2s ease;
}

/* estados ligado */
.app-switch__input:checked + .app-switch__track {
    background: #4361ee;
}
.app-switch__input:focus-visible + .app-switch__track {
    box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.25);
}

/* rótulo */
.app-switch__label {
    font-size: 0.8rem;
    font-weight: 500;
    color: #506690;
    white-space: nowrap;
}
.dark .app-switch__label { color: #a3b0c9; }

/* ── tamanho md (padrão) ── */
.app-switch--md .app-switch__track { width: 40px; height: 22px; }
.app-switch--md .app-switch__thumb { width: 18px; height: 18px; }
.app-switch--md .app-switch__input:checked + .app-switch__track .app-switch__thumb { left: 20px; }

/* ── tamanho sm ── */
.app-switch--sm .app-switch__track { width: 32px; height: 18px; }
.app-switch--sm .app-switch__thumb { width: 14px; height: 14px; }
.app-switch--sm .app-switch__label { font-size: 0.75rem; }
.app-switch--sm .app-switch__input:checked + .app-switch__track .app-switch__thumb { left: 16px; }
</style>
